export default {
      id: "reefer-success-usage",
      viewBox: "0 0 101 96",
      url: __webpack_public_path__ + "img/icons.svg#reefer-success",
      toString: function () {
        return this.url;
      }
    }